import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  console.error(
    '[Firebase] Missing REACT_APP_API_KEY or REACT_APP_PROJECT_ID. Copy .env.example to .env and restart npm start.'
  );
}

const app = initializeApp(firebaseConfig);

/** Analytics can throw in some browsers; never block app boot. */
let analytics = null;
isSupported()
  .then((ok) => {
    if (ok) analytics = getAnalytics(app);
  })
  .catch((err) => {
    console.warn('[Firebase] Analytics disabled:', err?.message || err);
  });

const functions = getFunctions(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

/** Avoid "already connected" crashes on hot reload. */
let emulatorsConnected = false;

if (process.env.REACT_APP_USE_EMULATORS === 'true' && !emulatorsConnected) {
  try {
    connectFunctionsEmulator(functions, '127.0.0.1', 5011);
    connectFirestoreEmulator(db, '127.0.0.1', 8085);
    emulatorsConnected = true;
  } catch (err) {
    const msg = err?.message || String(err);
    if (!/already|been called/i.test(msg)) {
      console.error('[Firebase] Emulator connect failed. Run: npm run emulators:start', err);
    }
  }
  try {
    connectStorageEmulator(storage, '127.0.0.1', 9199);
  } catch (_) {
    // Storage emulator optional
  }
}

export { app, analytics, functions };
export default app;
